/* =========================================================
   FARMOR'S — Find Us

   Portado de la seccion 8 de js/main.js. Cambia solo de donde salen los datos:
   antes FARMORS.retailLocations vivia en el bundle; ahora se baja el JSON del
   asset del tema, que el CDN cachea aparte del HTML.

   Ahora entra por dos puertas y normaliza a la misma forma:
     - metaobjects: <script id="locator-data"> con la lista plana de tiendas
     - respaldo:    el JSON del tema, que ya venia agrupado por ciudad
   De normalize() para abajo el codigo es el mismo de siempre.
   ========================================================= */
(function () {
  "use strict";

  var cfg = document.getElementById("locator-config");
  if (!cfg) return;

  var DATA = null;
  // El prototipo no tiene geolocalizacion: su propio JS anota «la referencia no
  // incluye use my location». Se deja en null para calcar el diseño; si algun
  // dia se agrega, renderRetail y renderMarkets ya saben ordenar por distancia.
  var origin = null;
  var map = null;
  var markers = [];

  /* ---------- helpers ---------- */

  // Haversine en millas. Igual que F.distanceMiles del prototipo.
  function distanceMiles(a, b) {
    var R = 3958.8;
    var toRad = function (d) { return (d * Math.PI) / 180; };
    var dLat = toRad(b.lat - a.lat);
    var dLng = toRad(b.lng - a.lng);
    var s =
      Math.pow(Math.sin(dLat / 2), 2) +
      Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.pow(Math.sin(dLng / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // Un termino matchea si aparece en la ciudad, el nombre o la direccion.
  // El ZIP entra por address2, que es donde vive ("Berkeley, CA 94709").
  function matches(city, store, q) {
    if (!q) return true;
    var hay = (city.city + " " + store.name + " " + (store.address1 || "") + " " + (store.address2 || "")).toLowerCase();
    return hay.indexOf(q) !== -1;
  }

  /* ---------- render ---------- */

  function renderRetail(q) {
    var box = document.getElementById("retail-list");
    if (!box || !DATA) return;

    var cities = DATA.cities
      .map(function (c) {
        var stores = c.stores.filter(function (s) { return matches(c, s, q); });
        return { city: c.city, lat: c.lat, lng: c.lng, stores: stores };
      })
      .filter(function (c) { return c.stores.length > 0; });

    // Con "Near me" el orden es por cercania; si no, alfabetico como el diseño.
    if (origin) {
      cities.sort(function (a, b) {
        return distanceMiles(origin, a) - distanceMiles(origin, b);
      });
    }

    if (!cities.length) {
      box.innerHTML = '<div class="store">No stores match that search.</div>';
      return;
    }

    box.innerHTML = cities.map(function (c) {
      var dist = origin
        ? '<div class="city-group__dist">' + distanceMiles(origin, c).toFixed(1) + " mi away</div>"
        : "";
      // Markup calcado de find-us.html: <div class="store">, NO <p>, y sin <br>
      // entre el nombre y la direccion — .store strong ya es display:block.
      // Con <p> entraba el margin-bottom: 11px global y con el <br> una linea
      // en blanco: la lista quedaba con el doble de aire que el diseño.
      var stores = c.stores.map(function (s) {
        return (
          '<div class="store" tabindex="0" role="button" data-lat="' + s.lat + '" data-lng="' + s.lng + '">' +
          "<strong>" + esc(s.name) + "</strong>" +
          esc(s.address1) + (s.address2 ? "<br>" + esc(s.address2) : "") +
          "</div>"
        );
      }).join("");
      return '<div class="city-group"><h3>' + esc(c.city) + "</h3>" + dist + stores + "</div>";
    }).join("");
  }

  function renderMarkets(q) {
    var grid = document.getElementById("markets-grid");
    if (!grid || !DATA) return;

    var list = DATA.markets.filter(function (m) {
      if (!q) return true;
      return (m.name + " " + m.schedule + " " + (m.address || []).join(" ")).toLowerCase().indexOf(q) !== -1;
    });

    if (origin) {
      list = list.slice().sort(function (a, b) {
        return distanceMiles(origin, a) - distanceMiles(origin, b);
      });
    }

    // Calcado de find-us.html: <article class="market-card"> con <div> para
    // .sched y .addr. Con <p> se colaba el margin-bottom global y las fichas
    // quedaban mas altas y despareja la grilla.
    grid.innerHTML = list.map(function (m) {
      var dist = origin
        ? '<div class="city-group__dist">' + distanceMiles(origin, m).toFixed(1) + " mi away</div>"
        : "";
      return (
        '<article class="market-card" tabindex="0" role="button" data-lat="' + m.lat + '" data-lng="' + m.lng + '">' +
        "<h3>" + esc(m.name) + "</h3>" + dist +
        '<div class="sched">' + esc(m.schedule) + "</div>" +
        '<div class="addr">' + (m.address || []).map(esc).join("<br>") + "</div>" +
        "</article>"
      );
    }).join("");
  }

  /* ---------- mapa ---------- */

  function buildMap() {
    var el = document.getElementById("map");
    // Leaflet viene de unpkg con defer: si no cargo (red caida, bloqueador),
    // la pagina sigue sirviendo — la lista de tiendas es lo que importa.
    if (!el || !DATA || typeof window.L === "undefined") return;

    var pin = cfg.dataset.pin || "#B51F28";
    map = window.L.map(el, { scrollWheelZoom: false }).setView([37.8, -122.3], 9);

    window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
      maxZoom: 18
    }).addTo(map);

    var pts = [];
    DATA.cities.forEach(function (c) {
      c.stores.forEach(function (s) {
        if (s.lat == null || s.lng == null) return;
        var m = window.L.circleMarker([s.lat, s.lng], {
          radius: 7, color: pin, fillColor: pin, fillOpacity: 0.85, weight: 2
        }).bindPopup("<strong>" + esc(s.name) + "</strong><br>" + esc(s.address1));
        m.addTo(map);
        markers.push(m);
        pts.push([s.lat, s.lng]);
      });
    });

    if (pts.length) map.fitBounds(pts, { padding: [30, 30] });
  }

  /* ---------- clic en tienda o market: centra el mapa ----------
     El prototipo lo llama focusOn(). Por eso .store y .market-card llevan
     cursor: pointer y :hover en el CSS: son operables, y con tabindex/role
     tambien por teclado. */
  function focusOn(el) {
    var lat = parseFloat(el.getAttribute("data-lat"));
    var lng = parseFloat(el.getAttribute("data-lng"));
    if (!map || isNaN(lat) || isNaN(lng)) return;
    map.setView([lat, lng], 14, { animate: true });
    var target = document.getElementById("map");
    if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  document.addEventListener("click", function (e) {
    var el = e.target.closest(".store[data-lat], .market-card[data-lat]");
    if (el) focusOn(el);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var el = e.target.closest(".store[data-lat], .market-card[data-lat]");
    if (!el) return;
    e.preventDefault();
    focusOn(el);
  });

  /* ---------- pestañas ---------- */

  document.addEventListener("click", function (e) {
    var tab = e.target.closest(".tab");
    if (!tab) return;
    document.querySelectorAll(".tab").forEach(function (t) {
      var on = t === tab;
      t.classList.toggle("is-active", on);
      t.classList.toggle("btn--primary", on);
      t.classList.toggle("btn--outline-dark", !on);
      t.setAttribute("aria-selected", String(on));
    });
  });

  /* ---------- normalizacion ----------
     El JSON de respaldo ya viene agrupado por ciudad. Los metaobjects vienen
     planos —una entrada por tienda, con su campo city— porque el admin no
     tiene forma de anidar, y porque asi el cliente da de alta una tienda sin
     preocuparse de si la ciudad ya existe: si es nueva, el grupo se crea solo.

     El orden es alfabetico por ciudad, que es como venia el diseño. La lat/lng
     del grupo es el promedio de sus tiendas: solo se usa para ordenar por
     cercania, que hoy no esta activo pero queda funcionando. */
  function normalize(json) {
    if (!json) return null;
    if (json.cities) return json;

    var byCity = {};
    (json.stores || []).forEach(function (s) {
      var city = (s.city || "").trim() || "Other";
      if (!byCity[city]) byCity[city] = { city: city, stores: [] };
      byCity[city].stores.push(s);
    });

    var cities = Object.keys(byCity).sort(function (a, b) {
      return a.localeCompare(b);
    }).map(function (name) {
      var c = byCity[name];
      var pts = c.stores.filter(function (s) { return s.lat && s.lng; });
      c.lat = pts.length ? pts.reduce(function (t, s) { return t + s.lat; }, 0) / pts.length : null;
      c.lng = pts.length ? pts.reduce(function (t, s) { return t + s.lng; }, 0) / pts.length : null;
      return c;
    });

    // El campo `address` del market es multilinea en el admin y un array en el
    // JSON: se lo deja siempre como array, que es lo que espera renderMarkets.
    // El address llega como array (JSON de respaldo) o como texto multilinea
    // (metaobject). Cualquier otra cosa —un campo mal tipado en el admin— se
    // descarta en vez de dejar pasar algo que despues rompa el .map de
    // renderMarkets: una ficha sin direccion es mucho mejor que la pagina
    // entera caida.
    var markets = (json.markets || []).map(function (m) {
      var addr = m.address;
      if (typeof addr === "string") {
        addr = addr.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
      } else if (!Array.isArray(addr)) {
        addr = [];
      }
      return {
        name: m.name, schedule: m.schedule, address: addr,
        lat: m.lat, lng: m.lng
      };
    });

    return { cities: cities, markets: markets };
  }

  /* ---------- arranque ---------- */

  function start(json) {
    DATA = normalize(json);
    if (!DATA) return;
    // Cada bloque por su cuenta: si uno falla, el otro igual se pinta. Antes
    // los tres compartian un try y un error en markets borraba las tiendas.
    try { renderRetail(""); } catch (e) {}
    try { renderMarkets(""); } catch (e) {}
    // Leaflet tiene defer, asi que puede no estar listo cuando resuelve el fetch.
    if (document.readyState === "complete") buildMap();
    else window.addEventListener("load", buildMap);
  }

  function fail() {
    var box = document.getElementById("retail-list");
    if (box) box.innerHTML = '<div class="store">Couldn\u2019t load store locations. Please refresh.</div>';
  }

  var inline = document.getElementById("locator-data");
  if (inline) {
    try { start(JSON.parse(inline.textContent)); } catch (e) { fail(); }
  } else if (cfg.dataset.src) {
    fetch(cfg.dataset.src)
      .then(function (r) { return r.json(); })
      .then(start)
      .catch(fail);
  } else {
    fail();
  }
})();
